import { useAuth } from "../../../context/auth";
import { useEffect, useMemo, useState } from "react";
import { DeleteDefect, GetDefects, PostDefect } from "../../../data/services";
import { toast } from "react-toastify";
import ConfirmDeleteModal from "../components/ConfirmDeleteModal";
import AdicionarDefeitos from "./AdicionarDefeitos";
import "./../admin.css";

const AdminDefeitos = () => {
  const { user } = useAuth();
  const profile = user?.profile;
  const isAdmin = profile === "superAdmin" || profile === "adminUnidade";

  const [defeitosOptions, setDefeitosOptions] = useState<any>([]);
  const [openAdicionar, setOpenAdicionar] = useState(false);
  const [selectedDefeito, setSelectedDefeito] = useState<any>(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    GetDefects(setDefeitosOptions);
  }, []);

  // Salvar e atualizar lista
  async function handleSaveDefeito(defeito: { tipoDefeito: string }) {
    try {
      await PostDefect(defeito);
      GetDefects(setDefeitosOptions);
      setOpenAdicionar(false)
      return true;
      
    } catch (error) {
      console.error(error);
      return false;
    }
  }

  const toggleModal = () => setIsModalOpen(!isModalOpen);

  const handleConfirmDelete = async () => {
    try {
      await DeleteDefect(selectedDefeito.idTipoDefeito);
      toast.success("Defeito deletado com sucesso!");
      setDefeitosOptions((prev: any[]) =>
        prev.filter(
          (item) => item.idTipoDefeito !== selectedDefeito.idTipoDefeito
        )
      );
    } catch (error) {
      toast.error("Erro ao deletar defeito.");
    } finally {
      toggleModal();
    }
  };

  const ListColumns = useMemo(() => {
    return (
      <>
        <td className="listProperty">Id</td>
        <td className="listProperty">Nome do defeito</td>
        {isAdmin && <td className="listProperty">Ações</td>}
      </>
    );
  }, []);

  const List = useMemo(() => {
    return (
      <>
        {defeitosOptions
          ?.sort(function (a: any, b: any) {
            if (a.name > b.name) {
              return 1;
            }
            if (a.name < b.name) {
              return -1;
            }
            return 0;
          })
          .map((item: any) => {
            return (
              <tr
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: 5,
                  borderBottom: "1px solid #dddddd",
                }}
              >
                <td className="listTd">{item.idTipoDefeito ?? "~~"}</td>
                <td className="listTd">{item.tipoDefeito ?? "~~"}</td>
                {/* <td className="listProperty">Tipo de defeito</td> */}
                {isAdmin && (
                  <div style={{ display: "flex", flex: 1, marginLeft: 3 }}>
                    {/* <button
                      className="editBtn"
                      onClick={() => {
                        setOpen((prev: any) => ({
                          ...prev,
                          open: true,
                          method: "putch",
                        }));
                        setInfo(item);
                      }}
                    >
                      Editar
                    </button> */}
                    <button
                      className="deleteUserBtn"
                      onClick={() => {
                        setSelectedDefeito(item);
                        setIsModalOpen(true);
                      }}
                    >
                      Deletar
                    </button>
                  </div>
                )}
              </tr>
            );
          })}
      </>
    );
  }, [defeitosOptions]);

  return (
    <div className="modalSignUp">
      <div className="content-header-button-and-title">
        <h1>Defeitos</h1>

        {isAdmin && (
          <button className="BtnClean" onClick={() => setOpenAdicionar(true)}>
            Adicionar
          </button>
        )}
      </div>

      <div className="contentList">{ListColumns}</div>
      <div className="content">
        <div className="containerListInfo">
          {defeitosOptions.length > 0 ? (
            <>{List}</>
          ) : (
            <div style={{ textAlign: "center" }}>
              <h1 style={{ margin: "35px 0", fontSize: 28 }}>
                Não há registros aqui
              </h1>
            </div>
          )}
        </div>
      </div>

      {/* Modal popup de adicionar defeitos */}
      {openAdicionar && (
        <AdicionarDefeitos
          onSave={handleSaveDefeito}
          onCancel={() => setOpenAdicionar(false)}
        />
      )}

      <ConfirmDeleteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        onConfirm={handleConfirmDelete}
        itemName={selectedDefeito?.tipoDefeito ?? ""}
      />
    </div>
  );
};

export default AdminDefeitos;
